import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewProject, UpdateProject, getAllLNProjects } from "../../Services/project-services";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import ButtonModal from "../Modals/buttonModal";
import { useNavigate } from "react-router-dom";
import { isAlphanumericAllSpecialCharacters } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { getActiveInsp } from "../../Services/inspectionagency-service";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { normalstyle } from "../../functions/welding-functions";
import { checkWpqNpcilLinking } from "../../Services/WI-services";

const normalizeStatus = (status) => {
  return status === "Active";
};

const getInitialProjectState = (action, rowdata) => {
  return action === "Edit" ? { ...rowdata, wld_status: normalizeStatus(rowdata.wld_status) } : {
    wld_status: true,
    wld_projectType: "LN",
    wld_ProjectNumber: "",
    wld_code: "",
    wld_equipnumber: "",
    wld_clientname: "",
    wld_criticalcode: "",
    wld_inspectionagency: "",
    wld_deleted: "",
    SK: "",
    PK: "Project",
    wld_createdby: "",
    wld_createdon: "",
    wld_updatedby: "",
    wld_updatedon: "",
    projectNo: "",
  };
};

const AddEditProjectMaster = (props) => {
  const { action, rowdata, onHide, setReload, reload } = props;
  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [ProjectNo, setProjectNo] = useState([]);
  const [dropinspection, setdropinspection] = useState([]);
  const [isInspectionAgencyReadOnly, setIsInspectionAgencyReadOnly] = useState(false);

  const history = useNavigate();
  const username = sessionStorage.getItem("UserName");
  const alertMessage = "";
  let formName = "Project";

  const fetchInspection = async () => {
    const result = await getActiveInsp();
    setdropinspection(result);
  };

  const checkProjectLinking = async (projectNumber, inspectionAgency) => {
    try {
      let body;
      if (inspectionAgency === "NPCIL") {
        body = {
          PK: "NpcilWpqLinking",
          SK: projectNumber
        };
      } else {
        body = {
          PK: "WPQ_Linking",
          SK: projectNumber
        };
      }
      
      console.log("Checking project linking with:", body);
      const result = await checkWpqNpcilLinking(body);
      console.log("Project linking result:", result);
      
      if (result && result.status === true) {
        setIsInspectionAgencyReadOnly(true);
      } else {
        setIsInspectionAgencyReadOnly(false);
      }
    } catch (error) {
      console.error("Error checking project linking:", error);
      setIsInspectionAgencyReadOnly(false);
    }
  };

  useEffect(() => {
    fetchInspection();
    fetchProjectNo();
    if (action === "Edit" && rowdata?.wld_ProjectNumber && rowdata?.wld_inspectionagency) {
      checkProjectLinking(rowdata.wld_ProjectNumber, rowdata.wld_inspectionagency);
    }
  }, [action, rowdata]);

  const fetchProjectNo = async () => {
    const result = await getAllLNProjects();
    setProjectNo(result);
  };

  const [ProjectObj, setProjectObj] = useState(getInitialProjectState(action, rowdata));

  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_code: {},
    wld_status: {},
    wld_ProjectNumber: {},
    wld_equipnumber: {},
    wld_clientname: {},
    wld_criticalcode: {},
    wld_inspectionagency: {},
    wld_deleted: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
    projectNo: {},
  });

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setProject",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    onHide();
    setReload(!reload);
  };

  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    setProjectObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setProjectObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_projectType: "LN",
        wld_ProjectNumber: "",
        wld_equipnumber: "",
        wld_clientname: "",
        wld_criticalcode: "",
        wld_inspectionagency: "",
        wld_deleted: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
        projectNo: "",
      }));
    } else if (action === "Edit") {
      setProjectObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_projectType: props.rowdata.wld_projectType,
        wld_ProjectNumber: props.rowdata.wld_ProjectNumber,
        wld_equipnumber: props.rowdata.wld_equipnumber,
        wld_clientname: props.rowdata.wld_clientname,
        wld_criticalcode: props.rowdata.wld_criticalcode,
        wld_inspectionagency: props.rowdata.wld_inspectionagency,
        wld_deleted: props.rowdata.wld_deleted,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
        projectNo: props.rowdata.projectNo,
      }));

    }
    setError((prevState) => ({
      ...prevState,
      wld_ProjectNumber: {},
      wld_equipnumber: {},
      SK: {},
    }));
  };

  const hasValidationErrors = () => {
    return error.SK.status ||
      error.wld_ProjectNumber.status ||
      error.wld_equipnumber.status ||
      error.wld_clientname.status ||
      error.wld_inspectionagency.status ||
      error.wld_criticalcode.status;
  };

  const validateProject = (action) => {
    let isError = false;
    if (ProjectObj.wld_ProjectNumber.trim() === "") {
      ProjectObj.wld_ProjectNumber = "";
      isError = true;
      error.wld_ProjectNumber = {
        status: true,
        message: "Project Number is required.",
      };
    }
    if (ProjectObj.wld_clientname.trim() === "") {
      ProjectObj.wld_clientname = "";
      isError = true;
      error.wld_clientname = {
        status: true,
        message: "Client Name is required.",
      };
    }
    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (hasValidationErrors()) {
      isError = true;
    }
    return isError;
  };

  const prepareProjectData = () => {
    ProjectObj.wld_status = ProjectObj.wld_status ? "Active" : "Inactive";
    ProjectObj.wld_projectType = "LN";

    if (action === "Add") {
      ProjectObj.wld_deleted = "N";
      ProjectObj.SK = ProjectObj.wld_ProjectNumber;
      ProjectObj.wld_createdby = username;
    } else {
      ProjectObj.wld_updatedby = ProjectObj.wld_createdby;
    }
  };

  const handleResponse = (resp) => {
    if (resp.message === "Success") {
      const message = action === "Edit"
        ? "Selected Project No. has been Updated successfully"
        : "Selected Project No. has been Added successfully";
      showSuccess(message);
    } else if (resp.message === "Duplicate") {
      showWarning(resp.message);
    } else {
      showWarning("Failed to Add/Update");
    }
    setReload(!reload);
    setShowForm(false);
    onHide();
  };

  const handleError = () => {
    showWarning("Failed to Add/Update");
    setShowForm(false);
    onHide();
  };

  const handleAdd = (e) => {
    prepareProjectData();
    const result = action === "Add" ? AddNewProject(ProjectObj) : UpdateProject(ProjectObj);
    result.then(handleResponse).catch(handleError);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateProject(action)) {
      setshowConfirmModel(true);
    }
  };

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Project successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} Project </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">

              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group className="ListW-input-select">
                    <div className="search-select">
                      <SearchSelect
                        id="wld_ProjectNumber"
                        name="wld_ProjectNumber"
                        className={""}
                        stylegreen={normalstyle}
                        data={ProjectNo}
                        disabled={action === "Edit"}
                        valueField={"projectNo"}
                        value={ProjectObj.wld_ProjectNumber}
                        labelField={"projectNo"}
                        placeholder=" "
                        onChange={(ProjectObj) => {
                        setProjectObj((prev) => ({
                          ...prev,
                          wld_ProjectNumber: ProjectObj.value,
                        }));
                      }}
                      ></SearchSelect>
                    </div>
                    <Form.Label>Project Number</Form.Label>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_equipnumber"
                        name="wld_equipnumber"
                        type="text"
                        maxLength="20"
                        // disabled={action === "Edit" && isInspectionAgencyReadOnly}
                        className={`asterisk ${error.wld_equipnumber.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ProjectObj.wld_equipnumber}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericAllSpecialCharacters(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_equipnumber: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_equipnumber">Equipment Number</Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_equipnumber.status && (
                      <Form.Text className="text-danger" style={{ position: "relative", bottom: "14px" }} >
                        {error.wld_equipnumber.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_clientname"
                        name="wld_clientname"
                        type="text"
                        maxLength="100"
                        // disabled={action === "Edit" && isInspectionAgencyReadOnly}
                        className={`asterisk ${error.wld_clientname.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ProjectObj.wld_clientname}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericAllSpecialCharacters(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_clientname: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_clientname">
                        Client Name
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {error.wld_clientname.status && (
                      <Form.Text className="text-danger" style={{ position: "relative", bottom: "14px" }} >
                        {error.wld_clientname.message}

                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row
                className="gx-3"
                style={{
                  position: "relative",
                  bottom: "13px",
                }}
              >
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_criticalcode"
                        name="wld_criticalcode"
                        type="text"
                        maxLength="5"
                        // disabled={action === "Edit"}
                        className={`asterisk ${error.wld_criticalcode.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ProjectObj.wld_criticalcode}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericAllSpecialCharacters(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_criticalcode: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_criticalcode">Critical Code</Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;&nbsp;
                    {error.wld_criticalcode.status && (
                      <Form.Text className="text-danger" style={{ position: "relative", bottom: "14px" }} >
                        {error.wld_criticalcode.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="g-select">
                    <Form.Select
                      id="wld_inspectionagency"
                      name="wld_inspectionagency"
                      type="text"
                      placeholder=" "
                      required
                      value={ProjectObj.wld_inspectionagency}
                      onChange={(e) => {
                        setProjectObj((prev) => ({
                          ...prev,
                          wld_inspectionagency: e.target.value,
                        }));
                      }}
                      disabled={action === "Edit" && isInspectionAgencyReadOnly}
                    >
                      <option value="" >Select</option>
                      {dropinspection?.map((item) => {
                        return (<option key={item.wld_code} value={item.wld_code}>{item.wld_code}</option>)
                      })}
                    </Form.Select>
                    <Form.Label className="frm-label" htmlFor="wld_inspectionagency">Inspection Agency</Form.Label>
                    <div className="required-text-select">
                      {error.wld_inspectionagency.status && (
                        <Form.Text className="text-danger">
                          {error.wld_inspectionagency.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + (ProjectObj.wld_status ? "activeToggleLabel" : "inactiveToggleLabel")}
                      name="wld_status"
                      checked={ProjectObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + (ProjectObj.wld_status ? "activeToggleLabel" : "inactiveToggleLabel")}>
                      {ProjectObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditProjectMaster;